import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setUpdatePaymentSystem = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_PAYMENT
            });
            dispatch(Action.SetGetListPaymentSystem({
                search: ''
            }))

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setUpdatePaymentSystem as SetUpdatePaymentSystem
}